/// <reference path="../../ng-services/chat.service.ts"/>

import { LightboxItem, LightboxService } from '../../ng-services/lightbox.service';

(function () {
    class LightboxUnsupportedComponent {
        static $inject = ['LightboxService'];
        public item!: LightboxItem;

        constructor(private lightboxService: LightboxService) {}

        $onInit() {
            console.log('item', this.item);
        }

        get downloadUrl() {
            return this.item.download_url;
        }

        get icon() {
            return this.lightboxService.getIcon(this.item.file_mimetype);
        }

        download() {
            window.open(this.downloadUrl, '_blank');
        }
    }

    angular.module('tradersyard').component('tyLightboxUnsupported', {
        template: `<div class="lightbox_unsupported">
    <img src="{{$ctrl.icon}}" alt="icon">
    <b>{{$ctrl.item.name}}</b>
    <a href="#" class="btn btn-default" ng-click="$ctrl.download()"><i class="fa fa-download"></i> Download</a>
</div>`,
        controller: LightboxUnsupportedComponent,
        bindings: {
            item: '<',
        },
    });
})();
